import React from "react";
import { Chip, Group } from '@mantine/core';

import { utils } from "../../utils/globalVariables";

const PrioritySelectorSingle = ({
    stateValue = '',
    fnOnChange,
}) => {
    return (
        <Chip.Group
            value={stateValue}
            onChange={fnOnChange}
        >
            <Group spacing='xs'>
                {Object.keys(utils.priority).map((key, index) => {
                    return (
                        <Chip
                            key={key}
                            value={String(utils.priority[key].value)}
                            radius='sm'
                            sx={(tema) => ({
                                '& label, & label[data-checked="true"]': {
                                    borderColor: `${tema.colorScheme === 'light' ? utils.priority[key].colorBgLight : utils.priority[key].colorBgDark} !important`,
                                    backgroundColor: `${tema.colorScheme === 'light' ? utils.priority[key].colorBgLight : utils.priority[key].colorBgDark} !important`,
                                },
                                '& label, & .mantine-Chip-checkIcon': {
                                    color: `#fff !important`
                                }
                            })}
                        >
                            {utils.priority[key].caption}
                        </Chip>
                    )
                })}
            </Group>
        </Chip.Group>
    )
}

export default PrioritySelectorSingle;